module.exports = "/images/vendor/flag-icon-css/flags/1x1/ua.svg?841d259d582b4c6f5585da31b4aab774";